import { makeAutoObservable, runInAction } from "mobx";
import { loginAPI } from "../../login/loginAPI";
import { boundarySettingsAPI } from "../../BoundarySettings/API/boundarySettingsAPI";
import { Cookies } from "react-cookie";
import { importJobAPI } from "../../ExcelImportExportModal/API/importJobAPI";
import { handleAPIError, MESSAGE_CODES } from "../../services/toast";
const roleMap = {
  1: "system_admin",
  2: "super_admin",
  3: "admin",
  4: "operator",
  5: "auditor", //第三方查證員
  6: "trial", //試用帳號
  7: "senior_admin",
};

const AUTH_COOKIE_KEYS = [
  "token",
  "userId",
  "role",
  "roleId",
  "userName",
  "rootId",
  "authId",
  "companyName",
  "access",
  "industryCode",
  "scopeType",
  // Legacy authentication state still consumed by Store/common.js.
  "Token",
  "email",
  "companyList",
  "focusArea",
  "userLevel",
  "siteModuleData",
  "usedRegion",
  "isBlueOnion",
  "blueOnionUserDisplayName",
  "isPCF",
  "isCTBC",
];

const mapOrgList = (orgList) =>
  orgList.map((org) => ({
    value: org.id,
    label: org.orgName,
    orgType: org.orgType,
    level: org.level,
    hierarchyNamePath: org.hierarchy_name_path,
    parentId: org.parentId,
    depth: org.depth,
    companyType: org.companyType,
    nodeStatus: org.nodeStatus,
  }));

const getScopeCompanyName = ({
  scopeType,
  orgList,
  companyList,
  authId,
  rootId,
}) => {
  if (scopeType === "COMPANY") {
    return (
      companyList.find((company) => company.id === rootId)?.companyName ||
      companyList.find((company) => company.parentId === null)?.companyName ||
      ""
    );
  }

  return orgList.find((org) => org.value === authId)?.label || "";
};

class CommonStore {
  cookies = new Cookies();

  token = this.cookies.get("token") || "";
  userId = this.cookies.get("userId") || "";
  role = this.cookies.get("role") || "";
  roleId = this.cookies.get("roleId") || "";
  userName = this.cookies.get("userName") || "";
  authId = this.cookies.get("authId") || "";
  rootId = this.cookies.get("rootId") || "";
  access = this.cookies.get("access") === "true";
  industryCode = this.cookies.get("industryCode") || "";
  companyName = this.cookies.get("companyName") || "";
  EACategory = [];
  version = "";

  orgList = [];

  lang =
    localStorage.getItem("i18nextLng") === "tw"
      ? "zh_tw"
      : localStorage.getItem("i18nextLng") || "en";

  theme = localStorage.getItem("theme") || "light";

  ////////停止跳轉路由判斷 (onclick)
  stopRoute = false;

  //////// 之後有機位以下面的取代
  pendingUrl = null;

  //////// 暫時處理多個Tab的行為紀錄
  pendingAction = null;

  //////// 判斷是哪個頁面正在編輯
  activeEditor = null;

  ////////是否要顯示excel匯入匯出modal
  showExcelImportExportModal = false;

  ////// 列出可用的 importType 與範例 DTO
  excelImportersList = [];

  //////匯出excel的type
  excelImportType = "";

  scopeType = this.cookies.get("scopeType") || "";

  companyList = JSON.parse(localStorage.getItem("companyList") || "[]");

  constructor() {
    makeAutoObservable(this);
    this._loadOrgListFromStorage();
  }

  get scopeId() {
    return this.scopeType === "COMPANY" ? this.rootId : this.authId;
  }

  get companyTreeRootId() {
    if (this.scopeType !== "COMPANY") return "";

    return (
      this.companyList.find((company) => company.parentId === null)?.id ||
      this.companyList.find((company) => company.depth === 0)?.id ||
      ""
    );
  }

  get companySelectorList() {
    return Number(this.roleId) === 2 || this.scopeType === "COMPANY"
      ? this.companyList
      : this.orgList;
  }

  _handleSetStopRoute = (val) => {
    this.stopRoute = val;
    console.log(this.stopRoute);
  };

  _handleSetRootId = (id) => {
    this.rootId = id;
  };

  _handleSetRole = (role) => {
    this.role = role;
  };

  _handleSetRoleId = (roleId) => {
    this.roleId = roleId;
  };

  _handleSetUserId = (userId) => {
    this.userId = userId;
  };

  _handleSetToken = (token) => {
    this.token = token;
  };

  _handleSetUserName = (userName) => {
    this.userName = userName;
  };

  _handleSetAuthId = (authId) => {
    this.authId = authId;
  };

  _handleSetAccess = (access) => {
    this.access = access;
  };

  _handleSetIndustryCode = (industryCode) => {
    this.industryCode = industryCode;
  };

  _handleSetCompanyNameValue = (companyName) => {
    this.companyName = companyName;
  };

  _handleSetScopeTypeValue = (scopeType) => {
    this.scopeType = scopeType;
  };

  _handleSetCompanyListValue = (companyList) => {
    this.companyList = companyList;
  };

  resetAuthState = () => {
    AUTH_COOKIE_KEYS.forEach((key) =>
      this.cookies.remove(key, { path: "/" }),
    );

    localStorage.removeItem("orgList");
    localStorage.removeItem("companyList");
    localStorage.removeItem("email_cooldown_time");

    this.token = "";
    this.userId = "";
    this.role = "";
    this.roleId = "";
    this.userName = "";
    this.authId = "";
    this.rootId = "";
    this.access = false;
    this.industryCode = "";
    this.companyName = "";
    this.scopeType = "";
    this.companyList = [];
    this.orgList = [];
    this.EACategory = [];
    this.excelImportersList = [];
    this.excelImportType = "";
    this.showExcelImportExportModal = false;
    this.stopRoute = false;
    this.pendingUrl = null;
    this.pendingAction = null;
    this.activeEditor = null;
  };

  _handleSetVersion = (version) => {
    this.version = version;
  };

  _handleSetLang = (lang) => {
    this.lang = lang === "tw" ? "zh_tw" : lang;
  };

  _handleSetTheme = () => {
    const newTheme = this.theme === "light" ? "dark" : "light";
    localStorage.setItem("theme", newTheme);
    this.theme = newTheme;
  };

  _handleSetEACategor = (data) => {
    this.EACategory = data;
  };

  //////// 清空pendingAction
  _handleClearPendingAction = () => {
    this.pendingAction = null;
  };

  //////// 判斷那一個頁面正在編輯且要打開哪個警告modal
  setActiveEditor(editor) {
    this.activeEditor = editor;
  }

  clearActiveEditor() {
    this.activeEditor = null;
  }

  tryLeave(action) {
    if (this.activeEditor?.isEdit()) {
      this.pendingAction = action;
      this.activeEditor.openWarning();
      return true;
    }

    action();
    return false;
  }

  async saveAndLeave() {
    const isSaved = await this.activeEditor?.save();
    if (isSaved === false) return false;

    this.pendingAction?.();
    this.pendingAction = null;
    return true;
  }

  leaveWithoutSave() {
    this.activeEditor?.clearEdit(); //清空編輯列
    this.pendingAction?.();
    this.pendingAction = null;
  }

  _loadOrgListFromStorage = () => {
    if (this.scopeType === "COMPANY") {
      this.orgList = [];
      localStorage.removeItem("orgList");
      return;
    }

    try {
      const raw = localStorage.getItem("orgList");
      if (raw) {
        this.orgList = JSON.parse(raw);
      }
    } catch (e) {
      console.error("orgList parse failed", e);
      this.orgList = [];
    }
  };

  _handleSetOrgList = async () => {
    if (this.scopeType !== "AUTH") {
      this.orgList = [];
      localStorage.removeItem("orgList");
      return [];
    }

    if (!this.authId) {
      throw new Error("AUTH scope requires authId");
    }

    const orgList = await loginAPI.getOrgList(this.authId);
    if (!Array.isArray(orgList)) {
      throw new Error("Invalid organization list response");
    }
    this.orgList = mapOrgList(orgList);

    localStorage.setItem("orgList", JSON.stringify(this.orgList));
    return this.orgList;
  };

  _handleSetCompanyList = async (userId) => {
    try {
      const data = await loginAPI.getCompanyListAPI(userId);
      if (!Array.isArray(data)) {
        throw new Error("Invalid company list response");
      }

      localStorage.setItem("companyList", JSON.stringify(data));
      this._handleSetCompanyListValue(data);
      return data;
    } catch (e) {
      console.error("companyList fetch failed", e);
      throw e;
    }
  };

  _handleSetCompanyName = async () => {
    const companyName = getScopeCompanyName({
      scopeType: this.scopeType,
      orgList: this.orgList,
      companyList: this.companyList,
      authId: this.authId,
      rootId: this.rootId,
    });
    this._handleSetCompanyNameValue(companyName);

    this.cookies.set("companyName", this.companyName, {
      path: "/",
    });
  };

  _handleRefreshScopeList = async () => {
    if (this.scopeType === "COMPANY") {
      return this._handleSetCompanyList(this.userId);
    }

    return this._handleSetOrgList();
  };

  _handleSetScopeType = async (userId) => {
    try {
      const scopeType = await loginAPI.getUserScopeType(userId);
      if (!scopeType || !["AUTH", "COMPANY"].includes(scopeType)) {
        throw new Error("Invalid user scope response");
      }

      this._handleSetScopeTypeValue(scopeType);

      if (scopeType === "AUTH") {
        const authRes = await loginAPI.getAuthIdAndRoleId(userId);
        if (!authRes?.authId) {
          throw new Error("AUTH scope requires authId");
        }
        this._handleSetAuthId(authRes.authId);
        this.cookies.set("authId", authRes.authId, { path: "/" });
      } else {
        this._handleSetAuthId("");
        this.cookies.remove("authId", { path: "/" });
        this.orgList = [];
        localStorage.removeItem("orgList");
      }

      await this._handleSetCompanyList(userId);
      await this._handleSetOrgList();
      await this._handleSetCompanyName();

      this.cookies.set("scopeType", scopeType, {
        path: "/",
      });
    } catch (e) {
      console.error("User scope type fetch failed", e);
    }
  };

  setEACategory = async (year, standardId) => {
    const EACategoryData = await boundarySettingsAPI.getEACategory(
      this.rootId,
      year,
      standardId,
    );
    this._handleSetEACategor(EACategoryData);
  };

  login = async (act, psw) => {
    try {
      const response = await loginAPI.login(act, psw);
      if (response) {
        await this._processLoginSuccess(response);
      }
    } catch (err) {
      if (err?.isLoginInitializationError) {
        handleAPIError(new Error(MESSAGE_CODES.LOGIN_FAILED), {
          scenarioCode: MESSAGE_CODES.LOGIN_FAILED,
          throwError: false,
          toastOptions: {
            toastId: "login-initialization-failed"
          }
        });
      }
      console.error("登入失敗:", err);
      throw err;
    }
  };

  ssoLogin = async (tempCode) => {
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    try {
      const [response] = await Promise.all([
        loginAPI.ssoLogin(tempCode),
        delay(2000), // 至少等待 2 秒
      ]);
      await this._processLoginSuccess(response);
    } catch (err) {
      console.error("SSO 登入失敗:", err);
      // SSO 失敗時確保登出，避免殘留狀態
      // this.logout();
      throw err;
    }
  };

  // 提取原始 login 方法的後半段邏輯，確保完全一致
  _processLoginSuccess = async (response) => {
    this.resetAuthState();

    const token = response?.access_token;
    const userId = response?.user_id;
    const userName = response?.username;

    if (!token || !userId || !userName) {
      throw new Error("Invalid login response");
    }

    try {
      const authRes = await loginAPI.getAuthIdAndRoleId(userId, token);
      const role = roleMap[authRes?.roleId];

      if (
        !authRes ||
        authRes.rootId == null ||
        authRes.roleId == null ||
        !role
      ) {
        throw new Error("Invalid authorization response");
      }

      const [companyList, scopeType] = await Promise.all([
        loginAPI.getCompanyListAPI(userId, token),
        loginAPI.getUserScopeType(userId, token),
      ]);

      if (!Array.isArray(companyList)) {
        throw new Error("Invalid company list response");
      }
      if (!scopeType || !["AUTH", "COMPANY"].includes(scopeType)) {
        throw new Error("Invalid user scope response");
      }

      if (scopeType === "AUTH" && authRes.authId == null) {
        throw new Error("AUTH scope requires authId");
      }

      const rawOrgList =
        scopeType === "AUTH"
          ? await loginAPI.getOrgList(authRes.authId, token)
          : [];

      if (!Array.isArray(rawOrgList)) {
        throw new Error("Invalid organization list response");
      }

      const orgList = mapOrgList(rawOrgList);
      const authId = authRes.authId ?? "";
      const companyName = getScopeCompanyName({
        scopeType,
        orgList,
        companyList,
        authId,
        rootId: authRes.rootId,
      });

      runInAction(() => {
        this.token = token;
        this.userId = userId;
        this.userName = userName;
        this.rootId = authRes.rootId;
        this.role = role;
        this.roleId = authRes.roleId;
        this.authId = authId;
        this.access = Boolean(authRes.isEdit);
        this.industryCode = authRes.industryCode ?? "";
        this.scopeType = scopeType;
        this.companyList = companyList;
        this.orgList = orgList;
        this.companyName = companyName;
      });

      const cookieValues = {
        token,
        userId,
        userName,
        rootId: authRes.rootId,
        role,
        roleId: authRes.roleId,
        authId,
        access: Boolean(authRes.isEdit),
        industryCode: authRes.industryCode ?? "",
        scopeType,
        companyName,
      };
      Object.entries(cookieValues).forEach(([key, value]) => {
        this.cookies.set(key, value, { path: "/" });
      });

      localStorage.setItem("companyList", JSON.stringify(companyList));
      localStorage.setItem("orgList", JSON.stringify(orgList));

      this._handleGetExcelImporters();
    } catch (error) {
      this.resetAuthState();
      const initializationError =
        error instanceof Error
          ? error
          : new Error("Login initialization failed", { cause: error });
      initializationError.isLoginInitializationError = true;
      throw initializationError;
    }
  };

  logout = async () => {
    try {
      await loginAPI.logout();
    } catch (err) {
      console.error("登出失敗:", err);
    } finally {
      this.resetAuthState();
      window.location.replace("/login");
    }
  };

  expireLogout = () => {
    this.resetAuthState();
    window.location.replace("/login");
  };

  //暫時pending page
  _handleSetPendingUrl = (url) => {
    this.pendingUrl = url;
  };

  ///開啟或關閉excel import / export modal
  _handleSetIsShowExcelImportExportModal = (value, type) => {
    this.showExcelImportExportModal = value;
    this.excelImportType = type;
  };

  _handleGetExcelImporters = async () => {
    try {
      const data = await importJobAPI.excelImporters();
      this.excelImportersList = Array.isArray(data) ? data : [];
    } catch (error) {
      console.error("Excel importer fetch failed", error);
      this.excelImportersList = [];
    }
  };

    //判斷公司下拉式選單是用哪個
get isCustomTree() {
  if (Number(this.roleId) === 2) {
    return true;
  }

  switch (this.roleId) {
    case "3":
    case "7":
      return this.scopeType === "COMPANY";
      
    case "4":
    default:
      return false; // 角色 4 與其他預設情況都回傳 false
  }
}

}

const commonStore = new CommonStore();
export default commonStore;
